import { SourceType } from '../utilities/Enums';
import { ProspectUserPreference, ProspectUserProfile } from './ProspectUserProfile';
import { ApiResult, httpRequest, Urls } from './Shared';
import { Event, UnitType } from './Property';
import { TourAccess } from './Prospect';

export interface SubmitGuestCardDto {
    preferences: ProspectUserPreference;
    source?: string;
    sourceType: SourceType;
    sessionId?: string;
    sourceMedium?: string | null;
    sourceCampaign?: string | null;
    unitTypeId?: number;
}

export interface GuestCard extends SubmitGuestCardDto {
    guestCardGuid: string;
    propertyId: number;
    profile: ProspectUserProfile;
    unitType: UnitType;
    entrataApplicationId: string;
    knockProspectId: string;
    oneSiteGuestCardId: string;
    oneSiteCustomerId: string;
}

export interface AddProspectRedirect {
    prospectToken: string;
    iOSUrl?: string;
    androidUrl?: string;
}

export interface Reservation {
    id: number;
    event: Event;
    utcEvent: Event;
    postTourDowntime: number;
}

export interface TourCreate {
    propertyId: number;
    contactInfo: GuestCard;
    tour: Reservation;
}

export enum PageProgress {
    IdVerification = 'ID Verification',
    CreditCardVerification = 'Credit Card Verification',
    Confirmation = 'Confirmation',
    TourScheduleSuccess = 'Tour Schedule - Success',
    TourScheduleFailure = 'Tour Schedule - Failure'
}

export enum ProspectVerificationStatus {
    NotRequired = 0,
    NotAttempted = 1,
    Succeeded = 2,
    Failed = 3,
    AlreadyVerified = 4
}

export enum ProspectVerificationType {
    CreditCard = 0,
    Id = 1
}

export interface ProspectVerificationStatusDto {
    verificationType: ProspectVerificationType;
    verificationStatus: ProspectVerificationStatus;
}

const TOUR_SIGNUP_URL = `${Urls.BASE_URL}/TourSignup`;
const RESERVATIONS_URL = '/reservations';

export const createGuestCard = (propertyId: number, guestCard: SubmitGuestCardDto) =>
    httpRequest<AddProspectRedirect>(
        `${TOUR_SIGNUP_URL}/${propertyId}/guestCard`,
        'post',
        guestCard
    );

export const updateGuestCard = (
    propertyId: number,
    guestCardGuid: string,
    guestCard: SubmitGuestCardDto
) =>
    httpRequest<AddProspectRedirect>(
        `${TOUR_SIGNUP_URL}/${propertyId}/guestCard/${guestCardGuid}`,
        'put',
        guestCard
    );

export const getGuestCard = (propertyId: number, guestCardGuid: string) =>
    httpRequest<GuestCard>(`${TOUR_SIGNUP_URL}/${propertyId}/guestCard/${guestCardGuid}`);

export const addReservation = (
    guestCardGuid: string,
    reservation: Event
): Promise<ApiResult<Reservation>> => {
    return httpRequest<Reservation>(
        `${TOUR_SIGNUP_URL}${RESERVATIONS_URL}/${guestCardGuid}`,
        'post',
        reservation
    );
};

export const updateReservation = (
    guestCardGuid: string,
    reservationId: number,
    update: Event
): Promise<ApiResult<Reservation>> => {
    return httpRequest<Reservation>(
        `${TOUR_SIGNUP_URL}${RESERVATIONS_URL}/${guestCardGuid}/${reservationId}`,
        'put',
        update
    );
};

export const updateProspectVerificationStatus = (
    guestCardGuid: string,
    status: ProspectVerificationStatusDto
) =>
    httpRequest<boolean>(
        `${TOUR_SIGNUP_URL}/reservation/${guestCardGuid}/verificationStatus`,
        'put',
        status
    );

export const scheduleTour = (propertyId: number, guestCardGuid: string) => {
    return httpRequest<TourAccess>(
        `${TOUR_SIGNUP_URL}/${propertyId}/tour/${guestCardGuid}`,
        'post'
    );
};

export const getReservationForGuestCard = (
    guestCardGuid: string
): Promise<ApiResult<Reservation>> => {
    return httpRequest<Reservation>(
        `${TOUR_SIGNUP_URL}${RESERVATIONS_URL}/${guestCardGuid}`,
        'get'
    );
};

export const updatePageProgress = (guestCardGuid: string, page: string) =>
    httpRequest<boolean>(`${TOUR_SIGNUP_URL}/pageProgress/${guestCardGuid}/${page}`, 'put');



// WEBPACK FOOTER //
// ./src/api/TourSignup.ts